import {useSelector} from 'react-redux';
import Selector from '../../../selectors/pages/freecash/invite';
import {navigate} from '../../../utils/navigation';

export default () => {
    const {user} = useSelector(Selector);
    
    return (
        <div className="block invite">
            <div className="layer">
                <div className="money"></div>
                <div className="girl"></div>
                <div className="money"></div>
            </div>
            <div className="layer">
                <div className="content">
                    <div className="title">Invite 10 friends<br/>and get free $10!</div>
                    
                    <div className="task-progress">
                        <div className="top">
                            <div className="left">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.75 9.1875H5.25C4.10668 9.18889 3.01059 9.64369 2.20214 10.4521C1.39369 11.2606 0.938889 12.3567 0.9375 13.5C0.937897 14.0469 1.15532 14.5713 1.54203 14.958C1.92874 15.3447 2.45311 15.5621 3 15.5625H9C9.54689 15.5621 10.0713 15.3447 10.458 14.958C10.8447 14.5713 11.0621 14.0469 11.0625 13.5C11.0611 12.3567 10.6063 11.2606 9.79786 10.4521C8.98941 9.64369 7.89332 9.18889 6.75 9.1875Z" fill="#2FF056"/>
                                    <path d="M6 8.8125C7.96751 8.8125 9.5625 7.21751 9.5625 5.25C9.5625 3.28249 7.96751 1.6875 6 1.6875C4.03249 1.6875 2.4375 3.28249 2.4375 5.25C2.4375 7.21751 4.03249 8.8125 6 8.8125Z" fill="#2FF056"/>
                                    <path d="M17.0634 12C17.0636 12.2709 17.0103 12.5392 16.9068 12.7895C16.8032 13.0398 16.6513 13.2673 16.4597 13.4588C16.2681 13.6504 16.0407 13.8023 15.7904 13.9059C15.5401 14.0095 15.2718 14.0627 15.0009 14.0625H11.7534C11.7926 13.8776 11.8127 13.6891 11.8134 13.5C11.8139 12.6823 11.6155 11.8768 11.2353 11.1529C10.855 10.4291 10.3044 9.80857 9.63086 9.34499C10.2804 8.75805 11.1254 8.43446 12.0009 8.43749H13.5009C14.4454 8.43828 15.3511 8.81387 16.0191 9.4818C16.687 10.1497 17.0626 11.0554 17.0634 12ZM15.5634 5.24999C15.5626 5.89756 15.3386 6.52506 14.9291 7.02672C14.5196 7.52837 13.9497 7.87348 13.3153 8.00386C12.681 8.13425 12.0212 8.04193 11.447 7.74248C10.8728 7.44303 10.4195 6.95476 10.1634 6.35999C10.263 5.99841 10.3135 5.62505 10.3134 5.24999C10.3135 4.8774 10.263 4.50651 10.1634 4.14749C10.4174 3.55106 10.8698 3.06073 11.4438 2.75944C12.0178 2.45815 12.6783 2.36442 13.3135 2.49411C13.9487 2.62379 14.5195 2.96893 14.9295 3.47111C15.3395 3.9733 15.5634 4.6017 15.5634 5.24999Z" fill="#2FF056"/>
                                </svg>

                                Invited friends
                            </div>
                            <div className="right">
                                <span>{user.referral_task}</span>/10
                            </div>
                        </div>
                        <div className="progress">
                            <div className="value" style={{width: `${user.referral_task > 10 ? '100' : ((user.referral_task / 10) * 100)}%`}}></div>
                        </div>
                    </div> 

                    <div className="buttons">
                        <div className="white-button" onClick={e => navigate('/invite')}>Invite friends</div>
                    </div>
                </div>
            </div>
        </div>
    )
}